<template>
    <div class="app-community">

        <!-- Banner -->
        <BannerCommunity />

        <!-- Highlight Grid -->
        <div class="grid">

            <div class="tile" aria-label="Monthly Events">
                <span class="tile-icon" aria-hidden="true">📅</span>
                <span class="tile-title">Monthly Events</span>
                <span class="tile-description">
                    <i>Join our recurring sessions</i> <i>to connect</i> <i>and grow together.</i>
                </span>
            </div>
            <div class="tile" aria-label="Cozy Space">
                <span class="tile-icon" aria-hidden="true">🏠</span>
                <span class="tile-title">Cozy Space</span>
                <span class="tile-description"><i>Relax in a welcoming hub</i> <i>curated by</i> <i>and for members.</i></span>
            </div>
            <div class="tile" aria-label="Your Feedback">
                <span class="tile-icon" aria-hidden="true">💬</span>
                <span class="tile-title">Your Feedback</span>
                <span class="tile-description"><i>Share ideas</i> <i>and shape</i> <i>the roadmap with direct input.</i></span>
            </div>
            <div class="tile" aria-label="Direct Support">
                <span class="tile-icon" aria-hidden="true">🤝</span>
                <span class="tile-title">Direct Support</span>
                <span class="tile-description"><i>Get in touch</i> <i>with our team</i> <i>whenever you need help.</i></span>
            </div>

        </div>

    </div>
</template>

<script>
import BannerCommunity from '@/components/common/banner/BannerCommunity.vue'

export default {
    name: 'AppCommunity',
    components: {
        BannerCommunity
    },
    data() {
        return {
        }
    },
    methods: {
    },
    mounted() {
    }
}
</script>

<style scoped>

.app-community {
    width: 100%;
    padding-bottom: 75px;
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.grid {
    padding: 4rem;
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.5rem;
    justify-items: center;
    justify-content: center;
    margin-inline: auto;
    max-width: calc(600px * 2 + 1.5rem);
}

.tile {
    background: linear-gradient(
        135deg, 
        rgb(var(--v-theme-color1)) 0%, 
        rgb(var(--v-theme-color2)) 50%,
        rgb(var(--v-theme-color3)) 100%
    );
    color: #ffffff;
    padding: 2rem;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
    box-shadow: 0 0px 35px rgb(var(--v-theme-shadow1));
    position: relative;
    overflow: hidden;
    user-select: none;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    width: 100%;
    max-width: 600px;
}

.tile::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(160deg, rgba(var(--v-theme-darkbase), 0.2), transparent 50%);
    mix-blend-mode: screen;
    pointer-events: none;
}

.tile:hover,
.tile:focus-visible {
    transform: translateY(-6px);
    box-shadow: 0 0px 40px rgba(var(--v-theme-shadow1), 0.35);
}

.tile-icon {
    font-size: 2.5rem;
    line-height: 1;
    filter: drop-shadow(0 6px 12px rgba(var(--v-theme-shadow1), 0.25));
}

.tile-title {
    font-size: 1.35rem;
    font-weight: 700;
}

.tile-description {
    font-size: 0.95rem;
    line-height: 1.6;
    max-width: 20rem;
    opacity: 0.92;
}

.tile:focus-visible {
    outline: 3px solid rgba(var(--v-theme-darkbase), 0.6);
    outline-offset: 4px;
}

@media (min-width: 600px) {
    .grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 800px) {
    .grid {
        padding: 3rem;
    }
}

@media (max-width: 600px) {
    .grid {
        padding: 2rem;
    }
}
</style>